export const capitalize = (text = '') => {
    return text.length !== 0
        ? `${text[0].toUpperCase()}${text.substring(1).toLowerCase()}`
        : '';
}